import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, Table, Row, Col, Form, Pagination, Container } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { useHistory } from 'react-router-dom';
import { var_api } from '../../constant';
import Swal from "sweetalert2";

const WorkingHoursActivity = () => {
  const [clientsSummary, setClientsSummary] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [popupLast30Days, setPopupLast30Days] = useState(false);
  const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const [serviceData, setServiceData] = useState([]);
  const history = useHistory();

  useEffect(() => {
    fetchClientSummary();
  }, [startDate, endDate]);

  function getFormattedDate(daysBeforeToday) {
    const date = new Date();
    date.setDate(date.getDate() - daysBeforeToday);
    return date.toISOString().split('T')[0];
  }

  const fetchClientSummary = async () => {
    try {
      const token = localStorage.getItem('token');
      // const userId = localStorage.getItem('userId');
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const response = await axios.get(
        `${var_api}/api/employee/team-working-hours/${formattedStartDate}/${formattedEndDate}`,
        { headers: { Authorization: `${token}` } }
      );
      setClientsSummary(response.data);
      setPopupLast30Days(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };

  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const filteredUsers = clientsSummary.filter((client) => {
    const name = client.name?.toLowerCase() || '';
    const email = client.email?.toLowerCase() || '';
    const mobileNo = client.mobile_no?.toString().toLowerCase() || '';
    const roleName = client.role_name?.toLowerCase() || '';
    return (
      name.includes(searchQuery.toLowerCase()) ||
      email.includes(searchQuery.toLowerCase()) ||
      mobileNo.includes(searchQuery.toLowerCase()) ||
      roleName.includes(searchQuery.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredUsers.length / pageSize);
  const paginatedUsers = filteredUsers.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const downloadExcel = () => {
    const data = paginatedUsers.map((client, index) => ({
      "S.No": index + 1,
      "Client": client.name,
      "Mobile No": client.mobile_no,
      "Email ID": client.email,
      "Date Of Birth": client.dob,
      "Role Name": client.role_name,
      "Total Amount": client.total_amount,
      "Total Duration": client.total_duration,
      "Total Paid Amount": client.total_paid_amount,
      "Description": client.description,
      "Advance Booking Service Count": client.advance_booking_service_count,
      "Booking Count": client.booking_count
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TeamData");
    XLSX.writeFile(workbook, "TeamData.xlsx");
  };

  return (
    <Container className="activity-container mx-auto">
  <Button variant="dark" onClick={() => history.push('/reports')} className="mb-4">
    <i className='bx bx-arrow-back'></i> Back
  </Button>
  <h2 className="mb-4 text-center">Working hours activity</h2>
  <p className="mb-4 text-center">Detailed view of team members worked hours, shifts, and timesheets</p>

  <div className="filters mb-4 d-flex justify-content-between">
    <Button variant="light" onClick={() => setPopupLast30Days(true)}>Date Filter</Button>
    <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search"
            style={{ width: '200px' }} // Adjust width as needed
        />
  </div>

  <Modal show={popupLast30Days} onHide={() => setPopupLast30Days(false)} centered>
    <Modal.Header closeButton>
      <Modal.Title>Filter Last 30 Days</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row className="mb-4">
        <Col>
          <Form.Label>Start Date</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </Col>
        <Col>
          <Form.Label>End Date</Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </Col>
      </Row>
      <Button variant="dark" onClick={fetchClientSummary}>Apply</Button>
      <Button variant="outline-secondary" onClick={() => setPopupLast30Days(false)} className="ms-2">Cancel</Button>
    </Modal.Body>
  </Modal>

  <Table responsive bordered hover className="text-center activity-table">
    <thead>
      <tr>
        <th>S.No.</th>
        <th>Profile Image</th>
        <th>Client</th>
        <th>Mobile No</th>
        <th>Email ID</th>
        <th>Date Of Birth</th>
        <th>Role Name</th>
        <th>Total Amount</th>
        <th>Total Duration</th>
        <th>Total Paid Amount</th>
        <th>Description</th>
        <th>Advance Booking Service Count</th>
        <th>Booking Count</th>
      </tr>
    </thead>
    <tbody>
      {paginatedUsers.length > 0 ? (
        paginatedUsers.map((client, index) => (
          <tr key={index}>
            <td>{(currentPage - 1) * pageSize + index + 1}</td>
            <td><img src={`${var_api}/${client.profile_image}`} alt="Profile" className="profile-image" width='65px' height='65px' /></td>
            <td>{client.name}</td>
            <td>{client.mobile_no}</td>
            <td>{client.email}</td>
            <td>{client.dob}</td>
            <td>{client.role_name}</td>
            <td>{client.total_amount}</td>
            <td>{client.total_duration}</td>
            <td>{client.total_paid_amount}</td>
            <td>{client.description}</td>
            <td>{client.advance_booking_service_count}</td>
            <td>{client.booking_count}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="13" className="text-center">No Data Available</td>
        </tr>
      )}
    </tbody>
  </Table>

  <Button variant="dark" onClick={downloadExcel} className="mt-3">
    Download as Excel
  </Button>

  <Pagination className="mt-4 justify-content-center">
    <Pagination.Prev onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>Previous</Pagination.Prev>
    {[...Array(totalPages).keys()].map((_, idx) => (
      <Pagination.Item key={idx} active={currentPage === idx + 1} onClick={() => setCurrentPage(idx + 1)}>
        {idx + 1}
      </Pagination.Item>
    ))}
    <Pagination.Next onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>Next</Pagination.Next>
  </Pagination>
</Container>

  );
};

export default WorkingHoursActivity;
